export default "__VITE_ASSET__Bx5YKXgp__"